const dev = {
  	API_ENDPOINT_URL: 'https://localhost:44340/',
	WSS_ENDPOINT_URL: 'wss://localhost:44340/ws'

	//API_ENDPOINT_URL: 'https://wms.samac.it:50443/',
	//WSS_ENDPOINT_URL: 'wss://wms.samac.it:50443/ws'
};

const prod = {
	//API_ENDPOINT_URL: 'http://192.168.100.219:3000/',
	//WSS_ENDPOINT_URL: 'ws://192.168.100.219:3000/ws'

	API_ENDPOINT_URL: 'https://wms.samac.it:50443/',
	WSS_ENDPOINT_URL: 'wss://wms.samac.it:50443/ws'

	//API_ENDPOINT_URL: 'https://91.187.198.218:50443/',
	//WSS_ENDPOINT_URL: 'wss://91.187.198.218:50443/ws'
};

const test = {
  API_ENDPOINT_URL: 'https://api.test.com',
  WSS_ENDPOINT_URL: 'wss://api.test.com/ws'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
